import { createAppTheme } from '@/theme/createAppTheme'
import { DEFAULT_ACCENT_ID } from '@/theme/accentPresets'

export { createAppTheme } from '@/theme/createAppTheme'
export { DEFAULT_ACCENT_ID } from '@/theme/accentPresets'

/** Theme mặc định (SSR / test / import tĩnh). App dùng `ThemeAccentProvider` để đổi chủ đề động. */
export const theme = createAppTheme(DEFAULT_ACCENT_ID)

export const apiUrl = process.env.REACT_APP_API_SERVICE_URL || (process.env.NODE_ENV === 'development' ? '' : '')

/**
 * Feature flag module Vận hành (C1 — gộp kho phase 2).
 * Off → ẩn dropdown "Vận hành" + chuông thông báo, không đăng ký route /van-hanh/* & /thong-bao,
 * tắt FCM push. Default OFF: chỉ bật khi set REACT_APP_ENABLE_VANHANH=true lúc build.
 * Lưu ý: CRA nướng env lúc build — đổi flag phải rebuild + redeploy (không hot).
 */
export const enableVanHanh = process.env.REACT_APP_ENABLE_VANHANH === 'true'
